import React from "react";
import { useEffect } from "react";
import { action_fetch_order_list_processing } from "../../../../../../../store/actions/pages/customer";
import { useStore } from "react-redux";
import { useParams } from "react-router-dom";
import { useQuery } from "../../../../../../hooks/common";
import { useSelector } from "react-redux";
import OrderList from "../fragments/order-list";
import OrderListEmpty from '../fragments/list-empty/index';
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import classes from './style.module.scss';
import useStyles from "isomorphic-style-loader/useStyles";
import { FormattedMessage } from "react-intl";


const OrderListProcessing = props =>{
	useStyles(classes);
	const store = useStore();
	const params = useParams();
	const query = useQuery();
	const pageCustomer = useSelector(state=>state.pageCustomer);    
	const { orderListProcessing } = pageCustomer;
	const dispatch = useDispatch();

	useEffect(async () => {
		if (window.__INITIAL_STATE__) {
			  // Allow the passed state to be garbage-collected
			  delete window.__INITIAL_STATE__
		  } else {
			  await OrderListProcessing.fetchData(store, params, query)
		  }
	}, []);

	const loadHandle = useCallback(() =>{
		dispatch(action_fetch_order_list_processing());
	}, []);

    return <div>
		{
			!(orderListProcessing?.skip===0 && orderListProcessing?.finished) && <React.Fragment>
				<div className={classes.ProcessingTip}>
					<span><FormattedMessage id="order_processing_shipping_date" defaultMessage="We usually take 3 to 7 business days to process your order." /></span> 
					<a href="/policy/shipping-policy"><FormattedMessage id="learn_more" defaultMessage="Learn More" /></a>
				</div>
			</React.Fragment>
		}

        <OrderList 
			request={loadHandle}
			orders={orderListProcessing?.data} 
			loading={orderListProcessing?.loading}
			finished={orderListProcessing?.skip!==0 && orderListProcessing?.finished}
		/>

		{
			orderListProcessing?.skip===0 && orderListProcessing?.finished && <OrderListEmpty />
		}
    </div>
}

OrderListProcessing.fetchData = async (store, params, search, headers) => {
	await store.dispatch(action_fetch_order_list_processing(headers));
}

export default OrderListProcessing;